module.exports = __webpack_public_path__ + "img/1.ad885370.png";